/* eslint-disable */
import * as L from 'leaflet';
import { Map as LeafletMap } from 'leaflet';
import { useEffect, useState, Key } from 'react';
import { createRoot } from 'react-dom/client';
import { useMap } from 'react-leaflet';
import { useLayers } from '../../context/LayersContext';
import { flattenLeaves } from '../../utils';
import { mockLayers } from '../../global/constants/layers';
import {
  LegendContainer,
  LegendHeader,
  LegendLabel,
  LegendMessage,
  LegendTitle,
} from './styles';
import './styles.css';

export function Legend() {
  const { layers } = useLayers();
  const map = useMap();
  const [expanded, setExpanded] = useState(false);
  const [legendData, setLegendData] = useState<any[]>([]);

  const allConfigs = flattenLeaves(mockLayers);
  const selectedConfigs = allConfigs.filter((c) => layers.includes(c.name));

  useEffect(() => {
    fetch(
      'https://gisepeprd2.epe.gov.br/arcgis/rest/services/SMA/WMS_Webmap_EPE/MapServer/legend?f=json'
    )
      .then((r) => r.json())
      .then((d) => setLegendData(d.layers));
  }, []);

  useEffect(() => {
    if (!map) return;

    const NoLayersControl = (L.Control as any).extend({
      options: { position: 'bottomright' },
      onAdd(): HTMLElement {
        const div = L.DomUtil.create('div', 'no-layers-message');
        L.DomEvent.disableClickPropagation(div);
        L.DomEvent.disableScrollPropagation(div);
        const root = createRoot(div);
        root.render(
          <LegendContainer expanded={true}>
            <div style={{ marginTop: 180 }} />
            <LegendMessage>Não há legendas para exibir.</LegendMessage>
            <LegendMessage>
              Primeiro selecione alguma camada que deseja visualizar.
            </LegendMessage>
          </LegendContainer>
        );
        return div;
      },
      onRemove() {},
    });

    const LegendControl = (L.Control as any).extend({
      options: { position: 'bottomright' },
      onAdd(): HTMLElement {
        const div = L.DomUtil.create('div', 'leaflet-legend');
        L.DomEvent.disableClickPropagation(div);
        L.DomEvent.disableScrollPropagation(div);
        const root = createRoot(div);

        root.render(
          <LegendContainer expanded={expanded}>
            <LegendHeader>
              <LegendTitle>Legendas</LegendTitle>
            </LegendHeader>
            {selectedConfigs.map(({ name, id }, idx) => {
              const layerLegend = legendData.find((l) => l.layerId === id);
              if (!layerLegend) return null;
              return (
                <div key={idx}>
                  <LegendLabel>{name}</LegendLabel>
                  {layerLegend.legend.map((item: any, j: number) => (
                    <div
                      key={j}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        marginBottom: 4,
                      }}
                    >
                      <img
                        src={`data:image/png;base64,${item.imageData}`}
                        alt={item.label ?? 'Legenda'}
                        style={{ width: 20, height: 20 }}
                      />
                      <span>{item.label ?? ''}</span>
                    </div>
                  ))}
                </div>
              );
            })}
          </LegendContainer>
        );

        return div;
      },
      onRemove() {},
    });

    let controlInstance: any;
    if (selectedConfigs.length === 0) {
      controlInstance = new NoLayersControl();
    } else {
      controlInstance = new LegendControl();
    }
    controlInstance.addTo(map);

    return () => {
      map.removeControl(controlInstance);
    };
  }, [map, selectedConfigs, expanded, legendData]);

  return null;
}
